export { default } from './HeaderBlockInfoLabel'
